// 跨組織範圍的「組織」篩選（M5-04；SPEC #kinio-kms-ui「跨組織範圍」）：VMS 範圍是「全部」而且範圍內有 2 個以上組織（dashboard by_org）時才出現；
// 多選 = API scope 帶多個 org:<id>（最多 20 個）。選項 = 有已啟用家戶的組織（by_org），依名稱排。
import { useTranslation } from 'react-i18next';
import { useScope } from '../../lib/scope';
import { useKmgrDashboard } from './hooks';
import { kmgrScopeOf, MAX_ORG_FILTER } from './model';
import { NS } from './parts';

export function OrgFilter({ value, onChange }: { value: string[]; onChange: (v: string[]) => void }) {
  const { t } = useTranslation(NS);
  const { scope } = useScope();
  const dash = useKmgrDashboard('all');
  const opts = [...(dash.data?.by_org ?? [])].sort((a, b) => (a.org_name ?? a.org_id).localeCompare(b.org_name ?? b.org_id));
  if (kmgrScopeOf(scope).scope !== 'all' || opts.length < 2) return null;
  const name = (id: string) => opts.find((o) => o.org_id === id)?.org_name ?? t('filter.org_unnamed');
  const label = value.length === 0 ? t('filter.org_all') : value.length === 1 ? name(value[0]) : t('filter.org_n', { n: value.length });
  const toggle = (id: string) => onChange(value.includes(id) ? value.filter((x) => x !== id) : [...value, id]);
  return (
    <details className="km-orgfilter" data-testid="km-org-filter">
      <summary className="btn btn-sm">{t('filter.org_label', { label })}</summary>
      <div className="km-orgfilter-menu" role="group" aria-label={t('filter.org')}>
        {opts.map((o) => {
          const on = value.includes(o.org_id);
          return (
            <label key={o.org_id} className="km-orgfilter-opt">
              <input type="checkbox" checked={on} disabled={!on && value.length >= MAX_ORG_FILTER} onChange={() => toggle(o.org_id)} data-org={o.org_id} />{' '}
              {o.org_name ?? t('filter.org_unnamed')}
            </label>
          );
        })}
        {value.length >= MAX_ORG_FILTER && <p className="muted km-sub">{t('filter.org_max', { n: MAX_ORG_FILTER })}</p>}
        {value.length > 0 && (
          <button type="button" className="btn btn-sm" onClick={() => onChange([])}>
            {t('filter.org_clear')}
          </button>
        )}
      </div>
    </details>
  );
}
